import { ApiClient } from "./api.ts";

export interface Rule {
    id?: string;
    name: string;
    path: string;
    methods: string[];
    domain_id: string;
    active: boolean;
    details: {
        routing?: {
            type: string;
            destinations: string[];
            config?: Record<string, string>;
            weights?: Record<string, number>;
        };
        rate_limit?: {
            limit: number;
            rate: string;
            multiplier?: number;
            identifier?: string;
            identifier_type?: string;
        };
        retry_policy?: {
            enabled: boolean;
            retry_on_methods: string[];
        };
    };
    created_at?: string;
    updated_at?: string;
    retry_policy?: {
        enabled: boolean;
        retry_on_methods: string[];
    };
}

export class RuleService {
    private static instance: RuleService;
    private api = ApiClient.getInstance();

    private constructor() { }

    public static getInstance(): RuleService {
        if (!RuleService.instance) {
            RuleService.instance = new RuleService();
        }
        return RuleService.instance;
    }

    public async listByDomain(domainId: string): Promise<Rule[]> {
        return this.api.request<Rule[]>(`/domain/${domainId}/rules`) as Promise<Rule[]>;
    }

    public async create(rule: Rule): Promise<Rule> {
        return this.api.request<Rule>(`/rule`, {
            method: 'PUT',
            body: JSON.stringify(rule)
        }) as Promise<Rule>;
    }

    public async update(id: string, rule: Rule): Promise<Rule> {
        return this.api.request<Rule>(`/rule/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(rule)
        }) as Promise<Rule>;
    }

    public async delete(id: string): Promise<void> {
        await this.api.request<void>(`/rule/${id}`, {
            method: 'DELETE'
        });
    }


    public async listPathsByDomain(domainId: string): Promise<string[]> {
        return this.api.request<string[]>(`/domain/${domainId}/paths`) as Promise<string[]>;
    }
}
